import { render } from "./ContentBlockSkip.vue?vue&type=template&id=20c1fdf4&scoped=true"
import script from "./ContentBlockSkip.vue?vue&type=script&lang=js"
export * from "./ContentBlockSkip.vue?vue&type=script&lang=js"

import "./ContentBlockSkip.vue?vue&type=style&index=0&id=20c1fdf4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3444732531/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c1fdf4"]])

export default __exports__